type UnknownRecord = Record<string, unknown>;

const isObject = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null;

const looksLikeRestaurant = (value: UnknownRecord): boolean => {
  return (
    typeof value._id === "string" &&
    typeof value.name === "string" &&
    isObject(value.rating)
  );
};

export const normalizeRestaurantPayload = <T>(payload: T): T => {
  if (Array.isArray(payload)) {
    return payload.map((item) => normalizeRestaurantPayload(item)) as T;
  }

  if (!isObject(payload)) {
    return payload;
  }

  const normalizedEntries = Object.entries(payload).map(([key, value]) => [
    key,
    normalizeRestaurantPayload(value),
  ]);

  const normalized = Object.fromEntries(normalizedEntries) as UnknownRecord;

  if (looksLikeRestaurant(normalized)) {
    return {
      ...normalized,
      googleMetadata: normalized.googleMetadata ?? null,
    } as T;
  }

  return normalized as T;
};
